import { GoToBack } from '@/features/navigate';
import { reportBackButtonStyles } from './styles';
import { Icon } from '@/shared/ui';
import { FC } from 'react';
import { useReportStore } from '@/entities/report';
import { usePersistStore } from '@/shared/lib/store';

interface ReportDetailHeaderProps {
    setType?: string;
    title: string | undefined;
}

export const ReportDetailHeader: FC<ReportDetailHeaderProps> = ({ setType, title }) => {
    const { stntReport, resetAll } = useReportStore();
    const { sMyClassMemberList } = usePersistStore();

    // 뒤로가기 시 리포트 상태 초기화
    const reportStateRemover = () => {
        resetAll();
    };

    const badge = setType === '1' ? '클래스' : setType === '2' ? 'URL' : '출력용';

    const findClaName = (claId: string) => {
        const targetId = claId?.split('-')[4];
        const _class = sMyClassMemberList?.find(
            (item) => item.classInfo.classSeq.toString() === targetId
        );
        if (_class) {
            return _class.classInfo.clsName;
        }
    };

    return (
        <div className="page-header-box box-style1">
            <GoToBack styles={reportBackButtonStyles} onClick={reportStateRemover}>
                <Icon icon="back2" />
                돌아가기
            </GoToBack>
            <p className="report-head">
                <span
                    className={`report-head__sort set${setType === '1' ? '1' : setType === '2' ? '3' : '2'}`}
                >
                    {badge}
                </span>
                <span className="report-head__title">{title}</span>
                {findClaName(stntReport?.claId) && (
                    <span className="report-head__class">{findClaName(stntReport?.claId)}</span>
                )}
            </p>
        </div>
    );
};
